var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.caches),function(cache){return _c('details-cache',{key:cache,attrs:{"instance":_vm.instance,"cache-name":cache}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }